import {
  COLOUR_DAMAGE_FAILED,
  COLOUR_DAMAGE_REQUEST,
  COLOUR_DAMAGE_SUCCESS,
} from "../../../../actions/Factory/Colour/colourDamage/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const colourDamageReducer = function (
  state = INIT_STATE,
  action
) {
  switch (action?.type) {
    case COLOUR_DAMAGE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case COLOUR_DAMAGE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case COLOUR_DAMAGE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
